import React from "react";
import { PageBuilderPageSliderFragment } from "types/graphql-types";
import Slider, { SliderSlide } from "components/Slider";
import PageBuilderSectionTitle from "./PageBuilderSectionTitle";
import SanityPageCard from "components/Card/SanityPageCard";
import { ComponentBackgroundColor } from "types/componentBackground";
import { graphql } from "gatsby";
import { isPresent } from "src/utils/checks";

interface PageBuilderPageSliderProps extends PageBuilderPageSliderFragment {
  cardBackgroundColor?: ComponentBackgroundColor;
}

const PageBuilderPageSlider: React.FC<PageBuilderPageSliderProps> = ({
  heading,
  items = [],
  cardBackgroundColor
}) => {
  const filteredItems = items.filter(isPresent);
  return (
    <React.Fragment>
      <PageBuilderSectionTitle {...heading} />
      <Slider variantColor={cardBackgroundColor}>
        {filteredItems.map((page) => {
          return (
            <SliderSlide key={page.id}>
              <SanityPageCard
                page={page}
                cardBackgroundColor={cardBackgroundColor}
              />
            </SliderSlide>
          );
        })}
      </Slider>
    </React.Fragment>
  );
};

export default PageBuilderPageSlider;

export const fragments = graphql`
  fragment PageBuilderPageSlider on SanityPageSlider {
    _key
    heading {
      ...SectionTitle
      ...SectionTitleCTAs
    }
    items {
      ...PageAsCard
    }
  }
`;
